<div class="sub-tabs">
  <ul class="nav nav-tabs">
    <li *townipIfUserHasTransFilingAccess class="nav-item">
      <a class="nav-link" routerLink="/invoices/translation-filing" routerLinkActive="active">
        Linguistic &amp; Filing
      </a>
    </li>
    <li *townipIfUserHasAnnuitiesAccess class="nav-item">
      <a class="nav-link" routerLink="/annuities/company/invoices" routerLinkActive="active">
        Renewal Services
      </a>
    </li>
  </ul>
</div>
<div class="sub-tabs-outlet">
  <ng-content></ng-content>
</div>
